import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MagicLinkPage } from '@/features/auth';

function MagicLink() {
  const { token } = Route.useSearch();
  return <MagicLinkPage token={token} />;
}

/**
 * Target of the sign-in email. No session redirect: the link may be for another account, and
 * exchanging it replaces the session cookie.
 */
export const Route = createFileRoute('/(public)/magic-link')({
  validateSearch: z.object({ token: z.string().min(1).optional() }),
  component: MagicLink,
});
